import "./App.css";
import SportySnap from "./SportySnap";

function App() {
  return (
    <div className="App">
      <SportySnap />
    </div>
  );
}

export default App;
